import * as React from "react";

import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leadingIcon, trailingIcon, ...props }, ref) => {
    return (
      <div
        className={cn(
          "flex w-full min-w-0 items-center gap-2",
          leadingIcon || trailingIcon
            ? "rounded-2xl border border-white/10 bg-white/5 px-3"
            : ""
        )}
      >
        {leadingIcon ? (
          <span className="text-white/60">{leadingIcon}</span>
        ) : null}
        <input
          type={type}
          className={cn(
            "flex h-10 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            leadingIcon || trailingIcon
              ? "border-none px-0 shadow-none focus-visible:ring-0"
              : "",
            className
          )}
          ref={ref}
          {...props}
        />
        {trailingIcon ? (
          <span className="text-white/60">{trailingIcon}</span>
        ) : null}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
